import React from "react";
import { Link, StaticQuery, graphql } from "gatsby";
import { containerStyle, rhythm } from "../utils/typography";
// import github from "../img/github-icon.svg";
// import logo from "../img/logo.svg";
import "../index.css";

const toLocal = url => {
  if (url.indexOf("//") !== -1) {
    const str = url.split("//")[1];
    return str.slice(str.indexOf("/"));
  } else {
    return url;
  }
};

const NavBar = () => (
  <StaticQuery
    query={graphql`
      query {
        wordpressMenusMenusItems(name: { eq: "MainMenu" }) {
          items {
            title
            object
            url
            description
            object_id
            post_name
          }
          id
          name
        }
        allWordpressCategory {
          edges {
            node {
              slug
              wordpress_id
            }
          }
        }
      }
    `}
    render={({ wordpressMenusMenusItems: menu }) => (
      <nav
        css={{
          ...containerStyle,
          padding: 0,
          display: "flex",
          "@media screen and (min-width: 768px)": {
            padding: `0 ${rhythm(3 / 4)}`
          }
        }}
      >
        {menu &&
          menu.items.map((item, i) => (
            <Link
              to={toLocal(item.url)}
              key={i}
              activeClassName="active"
              css={{
                padding: "0.6rem 0.9rem",
                color: "#fff",
                ":hover,:focus": {
                  color: "#fff",
                  backgroundColor: "hsla(209, 92%, 36%, 1)",
                  textDecoration: "none"
                }
              }}
            >
              {item.title}
            </Link>
          ))}
      </nav>
    )}
  />
);

export default NavBar;
